<template>
  <div class="news-edit">
    <el-form :model="form" label-width="80px" class="form">
      <el-form-item label="标题">
        <el-input v-model="form.title" />
      </el-form-item>
      <el-form-item label="内容">
        <div style="border: 1px solid #ccc; width:100%">
          <Toolbar :editor="editorRef" :default-config="toolbarConfig" style="border-bottom:1px solid #ccc" />
          <Editor
            v-model="form.content"
            :default-config="editorConfig"
            @onCreated="handleCreated"
            style="height:400px;overflow-y:hidden"
          />
        </div>
      </el-form-item>
      <el-form-item label="相关股票">
        <el-input v-model="form.stock_code" disabled />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" plain @click="openOriginal">查看原文</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="goBack">返回</el-button>
        <el-button type="primary" :loading="loading" @click="submitForm">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { ref, onMounted, shallowRef, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import stockClient from '../../utils/stockClient'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const form = ref({ id: null, title: '', content: '', stock_code: '', url: '' })
const editorRef = shallowRef()
const toolbarConfig = {}
const editorConfig = { placeholder: '请输入内容...' }

const handleCreated = (editor) => {
  editorRef.value = editor
}

const loadDetail = async () => {
  const id = route.params.id
  if (!id) return
  try {
    const res = await stockClient.get('/news/view', { params: { id } })
    Object.assign(form.value, res.data.data || res.data)
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const submitForm = async () => {
  loading.value = true
  try {
    await stockClient.post(
      `/news/update`,
      { id: form.value.id, title: form.value.title, content: form.value.content },
      { params: { id: form.value.id } }
    )
    ElMessage.success('保存成功')
    router.push('/stock/news')
  } catch (e) {
    ElMessage.error(e.toString())
  } finally {
    loading.value = false
  }
}

const openOriginal = () => {
  if (form.value.url) {
    window.open(form.value.url, '_blank')
  }
}

const goBack = () => {
  router.push('/stock/news')
}

onMounted(loadDetail)

onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor) editor.destroy()
})
</script>

<style scoped>
.news-edit {
  padding: 20px;
}
.form :deep(textarea) {
  min-height: 80px;
}
</style>

